<template>
  <CommonTabs
    :id="$route.params.id"
    resource="projects"
    :tabs="tabs"
    :components="components"
    :default-router="{ name: 'projects' }"
    :itemForPermission="[project, organization]"
    :tab="tab"
    :breadcrumbs="breadcrumbs"
  ></CommonTabs>
</template>

<script>
import EditProject from "../components/projects/EditProject";
import NewProject from "../components/projects/NewProject";
import TerminateProject from "../components/projects/TerminateProject";
import { title } from "../components/mixins/title";
import CommonTabs from "../components/common/tabs/CommonTabs";
import UsersProject from "../components/projects/UsersProject";
import ModulesProject from "../components/projects/ModulesProject";
export default {
  name: "Project",
  mixins: [title],
  components: { CommonTabs },
  data: () => ({
    components: {
      EditProject,
      TerminateProject,
      UsersProject,
      NewProject,
      ModulesProject
    },
    tab: 0
  }),
  computed: {
    tabs() {
      return this.$route.params.id
        ? [
            {
              title: "edit",
              component: "EditProject",
              permissions: "project.read"
            },
            {
              title: "users",
              component: "UsersProject",
              permissions: "project.read",
              tabClass: {
                "pl-0": true,
                "tab-item-full-width": true,
                "tab-item-padding-0": true
              }
            },
            {
              title: "modules",
              component: "ModulesProject",
              permissions: "project.update",
              tabClass: {
                "pl-0": true,
                "tab-item-full-width": true,
                "tab-item-padding-0": true
              }
            },

            {
              title: this.project.terminated_at
                ? "cancel-terminate"
                : "terminate",
              component: "TerminateProject",
              permissions: "project.delete"
            }
          ]
        : [
            {
              title: "new",
              component: "NewProject",
              permissions: "project.create"
            }
          ];
    },
    project() {
      return this.$store.getters["projectStore/getItem"];
    },
    organization() {
      return this.$store.getters["organizationStore/getItem"];
    },
    breadcrumbs() {
      if (this.project.id && this.$route.params.organization_id) {
        return [
          {
            text: this.$t("organizations.organizations"),
            to: {
              name: "organizations"
            },
            exact: true
          },
          {
            text: this.organization.name,
            to: {
              name: "organization",
              params: {
                id: this.organization.id
              }
            },
            exact: true
          },
          {
            text: this.$t("projects.projects"),
            to: {
              name: "projects"
            },
            exact: true
          },
          {
            text: this.project.name
          }
        ];
      }
      return [];
    }
  },
  watch: {
    "$route.params.id"() {
      this.getProject();
    },
    "$route.params.settings"() {
      this.setTab();
    },
    project() {
      this.setTitle();
    }
  },
  methods: {
    getArgumentForTitle() {
      return {
        chain: [this.$t("projects.projects"), this.project.name]
      };
    },
    getProject() {
      this.$route.params.id &&
        this.$store.dispatch("projectStore/get", {
          id: this.$route.params.id,
          options: {
            needReset: false
          }
        });
    },
    setTab() {
      if (this.$route.params.settings) {
        this.tab = 0;
      }
    }
  },
  mounted() {
    this.getProject();
    this.$route.params.organization_id &&
      this.$store.dispatch("organizationStore/get", {
        id: this.$route.params.organization_id
      });
    this.$store.dispatch("titleStore/setTitle", {
      chain: [this.$t("projects.projects")],
      index: 1
    });
    this.setTab();
  }
};
</script>

<style scoped></style>
